function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getTaskStatisticsProductList } from '@/api/task';
import dayjs from 'dayjs';
export default {
  data: function data() {
    return {
      todayDate: dayjs().format('YYYY-MM-DD')
    };
  },
  computed: {
    formData: function formData() {
      return [{
        label: '商品名称',
        prop: 'productName',
        defaultValue: '',
        type: 'input'
      }, {
        label: '日期',
        prop: 'browseDate',
        defaultValue: this.todayDate,
        type: 'date',
        options: {
          placeholder: '查询日期'
        }
      }];
    },
    columns: function columns() {
      return [{
        key: 'productId',
        visible: true,
        label: "\u5546\u54C1ID",
        width: 100
      }, {
        key: 'productName',
        visible: true,
        label: "\u5546\u54C1\u540D\u79F0",
        width: 160
      }, {
        key: 'productImage',
        visible: true,
        label: "\u5546\u54C1\u56FE\u7247",
        width: 100
      }, {
        key: 'browseCount',
        visible: true,
        label: "\u6D4F\u89C8\u91CF",
        width: 100
      }, {
        key: 'bounceRate2s',
        visible: true,
        label: "2\u79D2\u8DF3\u51FA\u7387(%)",
        width: 100
      }, {
        key: 'bounceRate5s',
        visible: true,
        label: "5\u79D2\u8DF3\u51FA\u7387(%)",
        width: 100
      }];
    }
  },
  created: function created() {},
  methods: {
    refreshList: function refreshList() {
      this.$refs.searchPage && this.$refs.searchPage.refresh();
    },
    resetList: function resetList() {
      this.$refs.searchPage && this.$refs.searchPage.resetSearch();
    },
    getList: function getList(query, sortMap) {
      var params = _objectSpread(_objectSpread({}, query), this.params);
      return getTaskStatisticsProductList(params).then(function (data) {
        var list = (data.list || []).map(function (item) {
          return item;
        });
        return {
          list: list,
          total: data.total
        };
      });
    }
  }
};